import Connection from './Connection';

interface PineconeConnectionArgs {
  indexName?: string;
  namespace?: string;
  k?: number;
  filter?: Record<string, any>;
}

class PineconeConnection extends Connection {
  constructor(connectionArgs: PineconeConnectionArgs) {
    super("pinecone", connectionArgs);
  }

  static fromJson(json: any): PineconeConnection {
    return new PineconeConnection(
      json.connection_args || json.connectionArgs || {}
    );
  }
}

export default PineconeConnection;